/**
 * Thin wrapper around the Telegram haptic-feedback API.
 *
 * Exposes three helpers — `impact()`, `notify()`, `select()` — that
 * silently no-op outside Telegram (when the SDK function isn't
 * `isAvailable()`). Components can call them anywhere without
 * defensive code.
 *
 * The Telegram API docs:
 *   https://docs.telegram-mini-apps.com/platform/haptic-feedback
 */
import {
  hapticFeedbackImpactOccurred,
  hapticFeedbackNotificationOccurred,
  hapticFeedbackSelectionChanged,
} from "@telegram-apps/sdk-react";

export type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
export type NotificationStyle = "error" | "success" | "warning";

export const haptic = {
  /** Tap feedback — use for button presses. */
  impact(style: ImpactStyle = "light"): void {
    if (hapticFeedbackImpactOccurred.isAvailable()) {
      hapticFeedbackImpactOccurred(style);
    }
  },
  /** Outcome feedback — use after a mutation lands. */
  notify(style: NotificationStyle): void {
    if (hapticFeedbackNotificationOccurred.isAvailable()) {
      hapticFeedbackNotificationOccurred(style);
    }
  },
  /** UI-element selection — use on picker / segmented-control changes. */
  select(): void {
    if (hapticFeedbackSelectionChanged.isAvailable()) {
      hapticFeedbackSelectionChanged();
    }
  },
};
